import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Container, Form, Row, Col, Button } from "react-bootstrap";
import AllDomainValue from '../../utils/mescs.json';
import Table from 'react-bootstrap/Table';
import ReactPaginate from 'react-paginate';

function MescModal(props) {
    const [value, setValue] = useState([]);

    const [show, setShow] = useState(false);

    const handleClose = () => {
        props.sendValues(value);
        setShow(false);
    };

    const handleShow = () => {
        setValue(props.value);
        setShow(true)
    };

    const handleChecked = (id) => {
        if (value.includes(id)) {
            var newValue = value.filter(item => item !== id);
            setValue(newValue);
        } else {
            setValue(prevState => [...prevState, id])
        }
    }

    const [search, setSearch] = useState('');
    const [itemOffset, setItemOffset] = useState(0);
    const itemsPerPage = 10;
    const ReturnDomainValue = () => {
        if (search) {
            const ListItems = AllDomainValue.filter(entry => Object.values(entry).some(val => typeof val === "string" && val.includes(search)));
            return ListItems;

        } else {
            return AllDomainValue;
        }
    }

    const endOffset = itemOffset + itemsPerPage;

    const currentItems = ReturnDomainValue().slice(itemOffset, endOffset);
    const pageCount = Math.ceil(ReturnDomainValue().length / itemsPerPage);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % ReturnDomainValue().length;
        setItemOffset(newOffset);
    };



    return (
        <>
            <Button variant="primary" onClick={handleShow}>
                انتخاب از لیست
            </Button>
            <Modal centered size="lg" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>دامنه فعالیت (براساس MESC نفت)</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Control placeholder='جستجو...' value={search} onChange={(e) => setSearch(e.target.value)} type="text" />
                    <Table striped bordered hover style={{ fontSize: 11 }}>
                        <thead>
                            <tr>
                                <th>انتخاب</th>
                                <th>نام فارسی</th>
                                <th>نام انگلیسی</th>
                                <th>کدنفت</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                currentItems.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>
                                                <Form.Check
                                                    type={'checkbox'}
                                                    id={`default-checkbox-${item.id}`}
                                                    value={item.id}
                                                    checked={value.includes(item.id)}
                                                    onChange={(e) => handleChecked(item.id)}
                                                    className='kng'
                                                />
                                            </td>
                                            <td>
                                                {item.PersianTitle}
                                            </td>
                                            <td>
                                                {item.EnglishTitle}
                                            </td>
                                            <td>
                                                {item.Code}
                                            </td>
                                        </tr>
                                    )
                                })
                            }

                        </tbody>
                    </Table>
                    <ReactPaginate
                        breakLabel="..."
                        nextLabel="بعدی >"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={5}
                        pageCount={pageCount}
                        previousLabel="< قبلی"
                        renderOnZeroPageCount={null}
                        activeClassName='activepage'
                        className=''
                        containerClassName='pagination align-items-center justify-content-evenly'
                    />

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        بستن
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default MescModal;